import { Link, useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "@/lib/lenis";
import { BrandMark } from "@/components/site/BrandMark";
import { API } from "@/lib/api";
import { waChat, waMsg } from "@/components/site/WhatsAppFloat";

const links = [
  { id: "inicio", label: "Início" },
  { id: "sobre", label: "Sobre" },
  { id: "especialidades", label: "Especialidades" },
  { id: "abordagem", label: "Abordagem" },
  { id: "horarios", label: "Horários" },
  { id: "contato", label: "Contato" },
];

export default function Footer({ content }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const go = (id) => {
    if (pathname === "/") scrollToId(id);
    else navigate(`/#${id}`);
  };
  const email = content?.email || "contato@tacilaine.com.br";
  const instagram = content?.instagram || "@tacilaine.psi";
  const waUrl = waChat(content?.whatsapp, waMsg(content));
  const logoUrl = content?.logo_path ? `${API}/files/${content.logo_path}` : null;
  const hideName = !!content?.logo_hide_name && !!logoUrl;

  return (
    <footer className="bg-[#2C332A] text-[#C7CFC2]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            {logoUrl ? (
              <img src={logoUrl} alt="Logo Tacilaine Almeida" className={hideName ? "h-14 object-contain" : "h-11 w-11 object-contain"} data-testid="footer-logo-img" />
            ) : (
              <BrandMark className="w-11 h-11" color="#C8A98E" />
            )}
            {!hideName && (
              <div className="leading-none">
                <p className="font-script text-3xl text-[#FDFBF7]">Tacilaine Almeida</p>
                <p className="font-body text-[10px] tracking-[0.35em] uppercase text-[#8A9A82] mt-1">Psicóloga · CRP 08/33677</p>
              </div>
            )}
          </div>
          <p className="mt-6 font-body text-sm leading-relaxed max-w-xs">
            Psicoterapia online com acolhimento, ética e sigilo. Você importa, você merece.
          </p>
          <p className="mt-4 font-body text-xs text-[#8A9A82] leading-relaxed max-w-xs" data-testid="footer-online-note">
            Atendimento psicológico exclusivamente online para adultos.
          </p>
        </div>

        <div>
          <p className="font-body text-xs tracking-[0.3em] uppercase text-[#8A9A82]">Navegação</p>
          <ul className="mt-5 space-y-3">
            {links.map((l) => (
              <li key={l.id}>
                <button onClick={() => go(l.id)} data-testid={`footer-link-${l.id}`} className="font-body text-sm text-[#C7CFC2] hover:text-[#FDFBF7] transition-colors duration-300">
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-body text-xs tracking-[0.3em] uppercase text-[#8A9A82]">Institucional</p>
          <ul className="mt-5 space-y-3">
            <li>
              <Link to="/politica-de-privacidade" data-testid="footer-link-privacidade" className="font-body text-sm text-[#C7CFC2] hover:text-[#FDFBF7] transition-colors duration-300">
                Política de Privacidade
              </Link>
            </li>
            <li>
              <Link to="/termos-de-uso" data-testid="footer-link-termos" className="font-body text-sm text-[#C7CFC2] hover:text-[#FDFBF7] transition-colors duration-300">
                Termos de Uso
              </Link>
            </li>
            <li>
              <button onClick={() => go("contato")} data-testid="footer-link-contato" className="font-body text-sm text-[#C7CFC2] hover:text-[#FDFBF7] transition-colors duration-300">
                Contato / Agendamento
              </button>
            </li>
          </ul>
        </div>

        <div>
          <p className="font-body text-xs tracking-[0.3em] uppercase text-[#8A9A82]">Contato</p>
          <ul className="mt-5 space-y-3 font-body text-sm">
            <li>{email}</li>
            <li>{instagram}</li>
            {waUrl && (
              <li>
                <a href={waUrl} target="_blank" rel="noreferrer" data-testid="footer-whatsapp"
                  className="underline-offset-4 hover:underline hover:text-[#FDFBF7] transition-colors">
                  WhatsApp: {content.whatsapp}
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>

      <div className="border-t border-[#FDFBF7]/10">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-body text-xs text-[#8A9A82]">
            <Link to="/login" data-testid="footer-admin-link" aria-label="Acesso" title="" className="cursor-default hover:text-[#8A9A82]">©</Link>
            {" "}{new Date().getFullYear()} Tacilaine Almeida · Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
